import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

import { computed } from 'vue';
import { createMemoryFormat, formatSi, parseSi } from '@shell/utils/units';

interface ClusterRow {
  mgmt?: ClusterRow;
  status?: { allocatable?: { memory?: string } };
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ClusterMemory',
  props: {
    row: {}
  },
  setup(__props: any) {

const props = __props;

const cluster = computed(() => props.row?.mgmt || props.row);

const allocatable = computed(() => {
  const parsed = (parseSi(cluster.value?.status?.allocatable?.memory) || 0).toString();

  return formatSi(parsed, createMemoryFormat(parsed));
});

// "0 GiB" means nothing was reported
const hasMemory = computed(() => !!allocatable.value && !allocatable.value.match(/^0 [a-zA-Z]/));

return (_ctx: any,_cache: any) => {
  return (hasMemory.value)
    ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(allocatable.value), 1))
    : (_openBlock(), _createElementBlock("span", _hoisted_2, "—"))
}
}

})